// Functions by nature, never field values to compute.
const NOT_RESOLVED = new Set(['eligible', 'icon']);

/**
 * `ad` with each function-valued field replaced by its result for `ctx`, or `ad` itself (by
 * identity) when none is a function. Runs before the copy overrides, so LaunchDarkly can still
 * reword a computed field.
 */
export const resolveAdFields = (ad, ctx) => {
  if (!ad) return ad;
  const resolved = {};
  for (const [key, value] of Object.entries(ad)) {
    if (typeof value === 'function' && !NOT_RESOLVED.has(key)) resolved[key] = value(ctx);
  }
  return Object.keys(resolved).length ? { ...ad, ...resolved } : ad;
};
